import { render, staticRenderFns } from "./ClientTaskIndex.vue?vue&type=template&id=0e1842ab&scoped=true"
import script from "./ClientTaskIndex.vue?vue&type=script&lang=js"
export * from "./ClientTaskIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e1842ab",
  null
  
)

export default component.exports